export const GET_LIST_START = "@environments/GET_LIST_START";
export const GET_LIST_SUCCESS = "@environments/GET_LIST_SUCCESS";
export const GET_LIST_FAIL = "@environments/GET_LIST_FAIL";
export const GET_DETAIL_START = "@environments/GET_DETAIL_START";
export const GET_DETAIL_SUCCESS = "@environments/GET_DETAIL_SUCCESS";
export const GET_DETAIL_FAIL = "@environments/GET_DETAIL_FAIL";
export const GET_CREDENTIALS_START = "@environments/GET_CREDENTIALS_START";
export const GET_CREDENTIALS_SUCCESS = "@environments/GET_CREDENTIALS_SUCCESS";
export const GET_CREDENTIALS_FAIL = "@environments/GET_CREDENTIALS_FAIL";
